import axios from "axios";

const axiosWrapper = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_SERVICE_URL,
  withCredentials: true
});

export default axiosWrapper;
